import React from 'react';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: "Declan",
    role: "Friend & Supporter",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/70xq9amg_137725.jpg",
    quote: "Bro the music is just getting better and better, your signature sound is there man 🦸 big up to ya ❤️💪 ... Let me get April out the way bro and we can set something up where we can meet, I want to get your autograph to 🙏 💯 No I ain't joking or being a dick bruv... I genuinely think your a star ⭐ and above that I think you got a heart ❤️ 💯 💪",
    featured: true
  },
  {
    id: 10,
    name: "Millz",
    role: "Professional DJ & Producer",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/p4wpgwh5_139524.jpg",
    quote: "Wicked vibes on this 🔥🔥"
  },
  {
    id: 11,
    name: "Millz",
    role: "Professional DJ & Producer",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/22fcqigo_139521.jpg",
    quote: "love this thank you 🔥🔥🔥"
  },
  {
    id: 2,
    name: "DJ SPECSX",
    role: "DJ",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/v8q14egb_139431.jpg",
    quote: "Yh Man U defo onto somin wid that ima defo get one done by u wiv few of my fave tunes only problem is my new fave tunes now r all urs 😂❤️"
  },
  {
    id: 3,
    name: "DJ NYTE-RYDA",
    role: "DJ & Producer",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/oq43jyi5_137752.jpg",
    quote: "Manners & Respect Bro 👊❤️ Would love to do a collaboration project featuring your music 🙏💯"
  },
  {
    id: 9,
    name: "Music Enthusiast",
    role: "Fan",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/80lgl7nc_137727.jpg",
    quote: "Your music really is a journey I love that. You've achieved what you wanted with that tune 💛"
  },
  {
    id: 4,
    name: "LISA",
    role: "One of our biggest supporters",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/s64owa1k_137739.jpg",
    quote: "Been so excited on this one 🔥🔥🔥 Another banger to add to the collection and still wanting more. well done 🔥🔥🔥❤️"
  },
  {
    id: 5,
    name: "DJ Rob Fury",
    role: "DnB Producer",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/awp0v9ph_137738.jpg",
    quote: "💯🔥🔥 My guys gone in hard with the breaks on this one 🎶🎶🎶🎶🎶"
  },
  {
    id: 7,
    name: "Jamie Latimer",
    role: "Illumination Co",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/gr4vqmdz_137745.jpg",
    quote: "4 am pumping track dropping the beats very well sit up and beg nice kick sub holding it all together ❤️put to gether very well aswell i like it some times less is more"
  },
  {
    id: 8,
    name: "CMP-DJ/PRODUCER-UK",
    role: "DJ & Producer",
    image: "https://customer-assets.emergentagent.com/job_numerounosounds/artifacts/hbwzlc0u_137742.jpg",
    quote: "levels bro 💯🔥💯🔥💯🔥"
  },
];

const Testimonials = () => {
  return (
    <section className="relative py-24 bg-black">
      {/* Background effect */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-green-900/10 via-black to-black"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            WHAT PEOPLE ARE
            <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
              SAYING
            </span>
          </h2>
          <div className="w-24 h-1 bg-green-500 mx-auto mt-6 shadow-[0_0_10px_rgba(0,255,136,0.8)]"></div>
          <p className="text-gray-400 mt-6 text-lg max-w-3xl mx-auto">
            From DJs to producers to fans worldwide - the underground is taking notice
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className={`group relative bg-zinc-900/50 backdrop-blur-sm border border-green-500/20 rounded-xl p-6 hover:border-green-500/60 transition-all duration-500 hover:shadow-[0_0_40px_rgba(0,255,136,0.3)] ${
                testimonial.featured ? 'md:col-span-2 lg:col-span-2' : ''
              }`}
            >
              {/* Quote Icon */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
                <Quote size={48} className="text-green-400" />
              </div>

              {/* Content */}
              <div className="relative z-10">
                {/* Quote */}
                <p className="text-gray-300 leading-relaxed mb-6 text-sm">
                  "{testimonial.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-green-500/20">
                  <div className="w-12 h-12 rounded-full bg-zinc-800 border-2 border-green-500/30 overflow-hidden flex-shrink-0">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                    <p className="text-green-400 text-xs">{testimonial.role}</p>
                  </div>
                </div>
              </div>

              {/* Glow effect on hover */}
              <div className="absolute inset-0 bg-green-500/0 group-hover:bg-green-500/5 rounded-xl transition-colors duration-500"></div>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Just over a year in, and the recognition keeps growing
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
